<ng-container *ngIf="newsList?.length > 0">
  <lib-section-header *ngIf="title && titleIcon"
                      [title]="title"
                      [titleIcon]="titleIcon"
                      [titleSize]="titleSize"
                      [colorScheme]="colorScheme"
  ></lib-section-header>
  <!-- Square News -->
  <lib-slider *ngIf="squareNews.length > 0"
              [colorScheme]="colorScheme" class="slider"
              [moreButtonTitle]="moreButtonTitle"
              [moreButtonLink]="moreButtonLink"
              [moreButtonRouterLink]="moreButtonRouterLink">
    <lib-slider-item class="slider-item rise-on-hover" *ngFor="let news of squareNews">
      <lib-news-card
        [news]="news"
        [colorScheme]="colorScheme"
        [layout]="squareCardLayout"
        [lazyLoadImage]="lazyLoadImages"
      ></lib-news-card>
    </lib-slider-item>
  </lib-slider>

  <!-- Compact News -->
  <div class="news-container">
    <lib-news-card *ngFor="let news of compactNews"
                   class="compact-card rise-on-hover"
                   [colorScheme]="colorScheme"
                   [news]="news"
                   [layout]="compactCardLayout"
                   [imageResolution]="largeImageRes"
                   [lazyLoadImage]="lazyLoadImages"
    ></lib-news-card>

    <!-- Split News-->
    <div class="split-news-container" *ngIf="splitNews.length > 0">
      <lib-news-card *ngFor="let news of splitNews"
                     class="split-card slide-right-on-hover"
                     [colorScheme]="colorScheme"
                     [news]="news"
                     [layout]="splitCardLayout"
                     [lazyLoadImage]="lazyLoadImages"
                     [splitAlignment]="splitCardAlignment"
      ></lib-news-card>
    </div>
  </div>
  <!--More Button-->
  <lib-more-button
    *ngIf="(moreButtonLink || moreButtonRouterLink) && squareNews.length === 0"
    class="more-button"
    [title]="moreButtonTitle"
    (click)="loadMoreClick.emit()"
    [link]="moreButtonLink"
    [routerLink]="moreButtonRouterLink"
    [colorScheme]="colorScheme">
  </lib-more-button>
</ng-container>

